<template>
  <div class="trade-overview-inner">
    <trade-header :headerData="hdData" @change="headerChangeHandler" :showTip="true"></trade-header>
    <Chart :options="options" :init-options="initOptions" autoresize />
  </div>
</template>

<script>
import Chart from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import { accMul, toFixed } from 'kw-bweb-util'
import { Line } from 'kw-bweb-chart-pc'
import TradeHeader from "../../trade-overview/header"
import dayjs from 'dayjs'
export default {
  props: {
    showYyData: {
      type:Boolean,
      default: true
    }
  },
  components: {
    TradeHeader,
    Chart
  },
  async created() {
    const ystDay = dayjs().subtract(1, 'day').format('YYYYMMDD')
    const param = {"cycleType":1,"occurtime":ystDay}
    this.hdData = await this.$store.dispatch('popHome/getTradeInfo', param)
    this.list = await this.$store.dispatch('popHome/getTradeDetail', param)
    this.buildOptions()
  },
  data () {
    return {
      hdData: {},
      list: [],
      currentKey: 1,
      currentDay: 1,
      currentTitle: `PV浏览量`,
      initOptions: {
        renderer: 'canvas'
      },
      options: {}
    }
  },
  computed: {
    cmsConfigTrade(){
      const cmsConfig = this.$store.state.cmsConfig || {}
      return cmsConfig.zhsTrade || []
    }
  },
  methods: {
    buildOptions() {
      let key = 'pv'
      let title = 'PV'
      let isPercent = false
      const filter = this.cmsConfigTrade.find(x => x.key * 1 === this.currentKey * 1)
      if (filter) {
        key = filter.dataIndex
        title = filter.lineTitle
        isPercent = filter.isPercent
      }
      const data = this.list || []
      const yData = data.map(v=> isPercent ? accMul(v[key], 100): toFixed(v[key],undefined,false))
      const yyData = [{
        name: this.showYyData ? title : '',
        data: yData,
      }]
      const max = Math.ceil(Math.max(...yData)/10) * 10
      const options = Line.getOptions({
        title: '',
          yShow: true,
          grid: {
            left: '5%',
            top: '30px',
            height: '50%'
          },
          color: ['#1C7AE5'],
          xData: data.map(v=>dayjs(v.occurtime).format('M.D')),
          yData: yyData,
          smooth: true,
          max: max,
          needArea: true,
          yAxisSplitLine: {
            lineStyle: {
              color: ['#EEEEEE'],
            }
          },
          showSymbol: false,
      })
      this.options = options
    },
    async headerChangeHandler ({ dayKey, indexKey, currentIndex }) {
      this.currentTitle = currentIndex.lineTitle
      if (this.currentDay !== dayKey) {
        this.currentDay = dayKey
        const endDay = dayjs().subtract(1, 'day').format('YYYYMMDD')
        const param = {"cycleType":dayKey,"occurtime":endDay}
        this.list = await this.$store.dispatch('popHome/getTradeDetail', param)
        this.hdData = await this.$store.dispatch('popHome/getTradeInfo', param)
      }
      if (this.currentKey !== indexKey) {
        this.currentKey = indexKey
      }
      this.buildOptions()
    }
  }
}
</script>

<style lang="scss" scoped>
.trade-overview-chart {
  width: 100%;
  height: 300px;
}
</style>
<style lang="scss">
.trade-overview-container{
  .echarts{
    width: 100%;
    height: 300px;
  }
}
</style>
